import { createContext, useContext } from 'react';

const SortableFlagContext = createContext(false);
export const SortableFlagProvider = SortableFlagContext.Provider;
export const useSortableFlag = () => useContext(SortableFlagContext);
